/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/** 字母，数字，下划线5-18位
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const reg = /^[a-zA-Z_0-9]{5,18}$/
  return reg.test(str)
}

/** 字母，数字，下划线，6-18位
 * @param {string} str
 * @returns {Boolean}
 */
export function validPassword(str) {
  // 检查长度是否在6-18位之间
  if (str.length < 6 || str.length > 18) {
    return false;
  }
  
  // 检查是否只包含字母、数字、下划线
  const allowedCharsReg = /^[a-zA-Z0-9_]+$/;
  if (!allowedCharsReg.test(str)) {
    return false;
  }
  
  // 检查是否同时包含字母、数字和下划线
  const hasLetter = /[a-zA-Z]/.test(str);
  const hasDigit = /[0-9]/.test(str);
  const hasUnderscore = /_/.test(str);
  
  return hasLetter && hasDigit && hasUnderscore;
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * validate phone
 * @param phone
 * @returns {boolean}
 */
export function validPhone(phone) {
  const re = /^1\d{10}$/
  return re.test(phone)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}
/**
 * @param {string} code
 * @returns {Boolean}
 */
export function validCard(code) {
  var city = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江 ", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外 " };
   var tip = "";
   var pass = true;  
   if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/i.test(code)) {
       tip = "身份证号格式错误";
       pass = false;
   }  
   else if (!city[code.substr(0, 2)]) {
       tip = "地址编码错误";
       pass = false;
   }
   else {
       //18位身份证需要验证最后一位校验位
       if (code.length == 18) {
           code = code.split('');
           //∑(ai×Wi)(mod 11)
           //加权因子
           var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
           //校验位
           var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
           var sum = 0;
           var ai = 0;
           var wi = 0;
           for (var i = 0; i < 17; i++) {
               ai = code[i];
               wi = factor[i];
               sum += ai * wi;
           }
           var last = parity[sum % 11];
           if (parity[sum % 11] != code[17]) {
               tip = "校验位错误,结尾是字母请注意大小写";
               pass = false;
           }
       }
   }
   // if(!pass) alert(tip);
   return pass;
  //return [pass, tip]
}